'use strict';

/*@ngInject*/
module.exports = function NavbarDirective($http, authService, $timeout) {
    return {
        controllerAs: 'vm',
        controller: function controller() {
            var vm = this;
            vm.menuItems = [];
            if (authService.isAuthenticated()) {
                $http.get("menu/getMenu").then(function (response) {
                    vm.menuItems = response.data;
                    $timeout(function () {
                        vm.menuLoaded = true;
                    }, 500);
                });
            }
        },
        template: require('./navbar.html')
    };
};


/** WEBPACK FOOTER **
 ** ./app/shared/navbar/navbar.directive.js
 **/